<template>
    <div class="booking-form__container">
        <div class="row">
            <div class="col-md-12 text-center" align="center">
                <p>
                    <a class="" v-on:click='openModal'>Unohtuiko salasana?</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import email from 'vuelidate/lib/validators/email';
    import swal from 'sweetalert2';
    import Messages from '../modules/Messages';
    import Routes from '../modules/Routes';

    export default {
        components: {},
        props: {
            token: {
                type: String
            }
        },
        data() {
            return {};
        },
        methods: {
            async openModal() {
                const { value: inputEmail } = await swal.fire({
                    title: 'Unohtuiko salasana?',
                    inputPlaceholder: 'Kirjoita sähköpostiosoitteesi',
                    input: 'email',
                    showCancelButton: true,
                    buttonsStyling: false,
                    confirmButtonText: 'Lähetä uusi salasana',
                    confirmButtonClass: 'swal2-button swal2-confirm',
                    cancelButtonText: 'Peruuta',
                    cancelButtonClass: 'swal2-button swal2-cancel',
                    inputValidator: (value) => {
                        let check = !value || !email(value);
                        return check && 'Tarkista antamasi sähköpostiosoite';
                    }
                });
                if (inputEmail) {
                    this.sendEmail(inputEmail);
                }
                this.$ga.event('Forgot password', 'Modal opened');
                gtag('event', 'view_forgot_password_form');
            },
            sendEmail(emailAddress) {
                let data = { username: emailAddress, _token: this.token };
                this.$http.post(Routes.getRoute('_public_api_retrieve_password'), data, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    Messages.successFromResponse(response);
                    this.$ga.event('Forgot password', 'Modal password sent');
                    gtag('event', 'send_forgot_password');
                }, (response) => {
                    Messages.errorFromResponse(response).then(() => {
                        this.openModal();
                    });
                    this.$ga.event('Forgot password', 'Password sending failed');
                });
            },
        }
    };
</script>
